import { Factory } from 'fishery'
import { v4 as uuidV4 } from 'uuid'
import { OpalApiComponent } from '@opallabs/api'
import { EMPTY_TO_MANY, linkageFromResource } from '@opallabs/json-api'
import { userResourceFactory } from './user'

type RichTextDocumentResourceV3 = OpalApiComponent<'V3', 'rich_text_document'>

export const richTextDocumentResourceFactory: Factory<RichTextDocumentResourceV3> =
  Factory.define<RichTextDocumentResourceV3>(() => {
    return {
      id: uuidV4(),
      type: 'rich_text_document',
      attributes: {
        body: null,
        client_library: 'tiptap/3.0',
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
      },
      relationships: {
        asset_references: EMPTY_TO_MANY,
        assets: EMPTY_TO_MANY,
        created_by_user: linkageFromResource(userResourceFactory.build()),
        embedded_resources: EMPTY_TO_MANY,
      },
    }
  })
